window.addEventListener('DOMContentLoaded', (event) => {
    if (toc_selector){
        const selectors = toc_selector.split(','); // Split the selectors string into an array
        let headers = [];

        // Run the query for each selector separately and add the results to the headers array
        selectors.forEach(selector => {
            const content = document.querySelector(selector.trim());
            const selectorHeaders = content.querySelectorAll('h2:not(.ignore_heading)');
            headers = [...headers, ...selectorHeaders];
        });

        const toc = document.querySelector('.toc'); // replace this with the actual class or ID of your table of contents container
        const tocList = document.createElement('ol'); // Create an ordered list element

        headers.forEach((header, index) => {
            // check if the header's content is not empty
            if (header.innerText.trim() !== '') {
                // add id to each header
                const id = `heading-${index}`;
                header.id = id;

                // create TOC entry
                const tocEntry = document.createElement('a');
                tocEntry.href = `#${id}`;
                tocEntry.innerText = header.innerText;
                tocEntry.addEventListener('click', function(event) {
                    event.preventDefault(); // prevent default action

                    // scroll to the element
                    const target = document.querySelector(`#${id}`);
                    target.scrollIntoView({behavior: "smooth", block: "start"});
                    target.click();
                });

                // create an li element
                const tocItem = document.createElement('li');
                // append the a element to the li
                tocItem.appendChild(tocEntry);

                // append the li element to the ol
                tocList.appendChild(tocItem);
            }
        });

        // append ol list to TOC container
        toc.appendChild(tocList);
    }
});
